import { ROUTES } from 'routes/_definition';
import { useShowroomTopNavbar } from 'common/components/MobileTopNavbar/utils/TopNavbarModules';
import { useShouldShowFeatureFlag } from 'common/features/FeatureFlag/hooks/useFeatureFlag';
import { useIsMobileScreen } from 'common/hooks/utils/useIsMobileScreen';
import React from 'react';
import { Route } from 'react-router-dom';
import defaultRouteProps from 'routes/routeUtils/defaultRouteProps';
import ArtistProfileTopNavbar from 'stacks/ArtistProfile/ArtistProfileTopNavbar/views/ArtistProfileTopNavbar';
import { getMatchRouteParams } from 'routes/routeUtils';
import ArtistHandleShowroomTitleShowcaseArtworkSlug from './showcase/[artworkSlug]';
import ArtistHandleShowroomTitle from './_index';

const ArtistHandleShowroomRouter: React.FC = () => {
  const {
    params: { artistHandle },
  } = getMatchRouteParams(ROUTES.ARTIST_HANDLE_SHOWROOM_TITLE);

  useShowroomTopNavbar({ handle: artistHandle ?? '' });

  const [isGlobalTopNavbarActive] = useShouldShowFeatureFlag('globalTopNavbar');
  const isMobile = useIsMobileScreen();
  const shouldShowGlobalTopNavbar = isGlobalTopNavbarActive && isMobile;

  return (
    <>
      {!shouldShowGlobalTopNavbar && <ArtistProfileTopNavbar artistHandle={artistHandle ?? ''} />}

      <Route {...defaultRouteProps.terminalRoute} path={ROUTES.ARTIST_HANDLE_SHOWROOM_TITLE}>
        <ArtistHandleShowroomTitle />
      </Route>
      <Route {...defaultRouteProps.terminalRoute} path={ROUTES.ARTIST_HANDLE_SHOWROOM_TITLE_SHOWCASE_ARTWORK_SLUG}>
        <ArtistHandleShowroomTitleShowcaseArtworkSlug />
      </Route>
    </>
  );
};

export default ArtistHandleShowroomRouter;
